import React from "react";

import { TableCell } from "../../..";
import { MenuAction } from "../../DataTable.types";
import MoreButton from "../../../MoreButton";
import { useStyles } from "./MoreMenu.styles";

export type MoreMenuProps<T extends { [key: string]: any }> = {
  row: T;
  actions: MenuAction<T>[];
  sidePadding?: number;
};

function MoreMenu<T extends { [key: string]: any }>(props: MoreMenuProps<T>) {
  const { row, actions } = props;

  const classes = useStyles(props);

  const visibleActions = actions.filter((action) => {
    return !action.visible || action.visible?.(row);
  });

  return (
    <TableCell className={classes.root}>
      <div className={classes.wrap}>
        <MoreButton
          className={classes.moreButton}
          actions={visibleActions}
          clickParam={row}
        />
      </div>
    </TableCell>
  );
}

export default MoreMenu;
